import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {ApiResponse} from "../../../modules/base/repository/entity/base.entity";

@Injectable({
  providedIn: 'root'
})
export class UploadRepository {

  constructor(private http: HttpClient) {
  }

  upload(companyCode: string, formData: FormData): Observable<any> {
    const headers = new HttpHeaders({
      'X-Company': companyCode
    });
    return this.http.post<any>(environment.baseUrl + `/upload/image`, formData, {
      reportProgress: true,
      observe: 'events',
      headers: headers
    })
  }

  delete(companyCode: string, filename: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Company': companyCode
    });
    return this.http.delete<any>(environment.baseUrl + `/upload/image/${filename}`, {
      headers: headers
    })
  }
}
